import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({
   providedIn: 'root' 
})
export class AuthRedirectUriResolver implements Resolve<void> {
    constructor(private readonly oauthService: OAuthService) {}

    resolve(): void {
        setTimeout(() => {
            this.oauthService.redirectUri = window.location.href.replace(window.location.search,'');
        });
        
    }
}